import { apiRequest, apiResponse } from "@/shared/api/client";

export interface Subscribe {
  id?: number | null;
  name?: string | null;
  year?: string | null;
  type?: string | null;
  tmdbid?: number | null;
  doubanid?: string | null;
  bangumiid?: number | null;
  season?: number | null;
  poster?: string | null;
  vote?: number | null;
  description?: string | null;
  total_episode?: number | null;
  lack_episode?: number | null;
  completed_episode?: number | null;
  state?: string | null;
  username?: string | null;
  best_version?: number | null;
}

/** 订阅状态文案 */
export function subscribeStateLabel(state?: string | null): string {
  switch (state) {
    case "R":
      return "订阅中";
    case "P":
      return "已暂停";
    case "S":
      return "已完成";
    case "N":
      return "新建";
    default:
      return state || "未知";
  }
}

export function listSubscribes() {
  return apiRequest<Subscribe[]>("/api/v1/subscribe/");
}

export function updateSubscribeStatus(id: number, state: "R" | "P" | "S") {
  return apiResponse(
    `/api/v1/subscribe/status/${id}?state=${encodeURIComponent(state)}`,
    { method: "PUT" },
  );
}

export function deleteSubscribe(id: number) {
  return apiResponse(`/api/v1/subscribe/${id}`, { method: "DELETE" });
}

export function searchSubscribe(id: number) {
  return apiResponse(`/api/v1/subscribe/search/${id}`);
}

export function createSubscribe(body: Partial<Subscribe>) {
  return apiResponse<{ id?: number }>("/api/v1/subscribe/", {
    method: "POST",
    body,
  });
}
